import type { ReactNode } from "react";
import { useLottieLoader } from "./useLottieLoader";

/**
 * Why-Folio illustration: renders the static line SVG for SSR / first paint,
 * then crossfades to the colored Lottie animation on the client (mirrors the
 * legacy WelcomeTabFolioAI FeatureCard). Sized to the v2 slot (~110px tall).
 */
export function WhyIllustration({
  svg,
  lottie,
}: {
  svg: ReactNode;
  lottie: ReactNode;
}) {
  const { showLottie } = useLottieLoader(100);

  return (
    <div className="relative flex h-[110px] w-[110px] items-center justify-center">
      <div
        className={`flex h-full w-full items-center justify-center transition-opacity duration-700 ease-in-out [&>svg]:h-full [&>svg]:w-auto ${
          showLottie ? "opacity-0" : "opacity-100"
        }`}
      >
        {svg}
      </div>
      <div
        className={`absolute inset-0 flex items-center justify-center transition-opacity duration-700 ease-in-out [&_svg]:!h-full [&_svg]:!w-auto ${
          showLottie ? "opacity-100" : "opacity-0"
        }`}
      >
        {showLottie && lottie}
      </div>
    </div>
  );
}
